import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";

/* ================= COMPONENTS ================= */
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CODNoticeSection from "./components/CODNoticeSection";
import GlobalBackground from "./components/GlobalBackground";

/* ================= PAGES ================= */
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Infrastructure from "./pages/Infrastructure";
import Quality from "./pages/Quality";
import Blogs from "./pages/Blogs";
import Contact from "./pages/Contact";
import BlogDetail from "./pages/BlogDetail";

/* ================= PAGE ANIMATION WRAPPER ================= */
function PageWrapper({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.45, ease: "easeInOut" }}
      className="min-h-screen"
    >
      {children}
    </motion.div>
  );
}

/* ================= SCROLL TO TOP ================= */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

/* ================= MAIN LAYOUT ================= */
function AppLayout() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />

      {/* Top Notice */}
      <CODNoticeSection />

      {/* Navbar */}
      <Navbar />

      <GlobalBackground>
        <div className="relative min-h-screen">

          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>

              <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />

              <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />

              <Route path="/products" element={<PageWrapper><Products /></PageWrapper>} />

              <Route path="/products/:id" element={<PageWrapper><ProductDetail /></PageWrapper>} />

              <Route path="/cart" element={<PageWrapper><Cart /></PageWrapper>} />

              <Route path="/infrastructure" element={<PageWrapper><Infrastructure /></PageWrapper>} />

              <Route path="/quality" element={<PageWrapper><Quality /></PageWrapper>} />

              <Route path="/blogs" element={<PageWrapper><Blogs /></PageWrapper>} />

              <Route path="/blogs/:slug" element={<PageWrapper><BlogDetail /></PageWrapper>} />

              <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />

              {/* ✅ 404 Page Fallback */}
              <Route
                path="*"
                element={
                  <PageWrapper>
                    <div className="flex items-center justify-center h-screen text-white text-2xl">
                      404 - Page Not Found
                    </div>
                  </PageWrapper>
                }
              />

            </Routes>
          </AnimatePresence>

          {/* Footer */}
          <Footer />

        </div>
      </GlobalBackground>
    </>
  );
}

/* ================= ROOT ================= */
export default function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}